import {StringOrNumber} from '@macmillanplatform/ui-core/types';
import {formatDateMMDDYYY_HH_MM_AMPM} from '@macmillanplatform/ui-core/utils';

import {FALLBACK_VALUE} from '../constants';
import {Nullable} from '@/types';

export const withFallback = <T>(
  value: Nullable<T>,
  fallback = FALLBACK_VALUE
) => value || fallback;

export const formatDateUniversal = (
  date: Nullable<StringOrNumber | Date>,
  {fallback = FALLBACK_VALUE, formatter = formatDateMMDDYYY_HH_MM_AMPM} = {}
) => withFallback(date && formatter(new Date(date)), fallback);
